export default __webpack_public_path__ + "static/warning-messages-awareness-dont-07f3cac781a58544cfe7ec022006c477bef51e5948fc4e63792f47743bcd050f.png";